import React from 'react'
import ReactPlayer from 'react-player/youtube'
// import songs from '../Music/songs'
//import _ from 'lodash'

const YouTubePlayer = () => {
    // let youTubeURLs = _.map(songs, (thisSong,index) => {
        
    //         return thisSong.youtube
        
        
    // })
    return <ReactPlayer 
        url={'https://www.youtube.com/watch?v=iNKaX7baGRc'}
        controls={true}
        config={{
            youtube:{
                    playerVars:{ 
                    listType:'playlist',
                    list:'PLEsmJ45uILbWjpwZxzxBSalcY0zDc9JSG'
                }
            }
        }}
        width="100%"
        height="100%"
    />
}

export default YouTubePlayer